// Fino — Bundle Add-on (instant sync, compare-at price, swatch support)
(function () {
  'use strict';

  // ---- Helpers ----

  function parseVariants(bundle) {
    const dataEl = bundle.querySelector('[data-bundle-variants]');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[Fino Bundle] Could not parse variants JSON', e);
      return null;
    }
  }

  function getChosenOptionValues(bundle) {
    const selectedPills = bundle.querySelectorAll('.bundle-addon__pill.is-selected');
    const chosen = [];
    selectedPills.forEach((pill) => {
      const idx = parseInt(pill.dataset.bundleOptionIndex, 10);
      chosen[idx] = pill.dataset.bundleOptionValue;
    });
    return chosen;
  }

  function findMatchingVariant(bundle) {
    const data = parseVariants(bundle);
    if (!data) return null;
    const variants = data.variants;

    const hasPills = bundle.querySelectorAll('.bundle-addon__pill').length > 0;
    if (!hasPills) return variants[0] || null;

    const chosen = getChosenOptionValues(bundle);
    return variants.find((v) => v.options.every((opt, i) => opt === chosen[i])) || null;
  }

function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  function updateBundlePriceAndCompare(bundle) {
    const variant = findMatchingVariant(bundle);
    if (!variant) return;

    const priceEl = bundle.querySelector('[data-bundle-price]');
    const compareEl = bundle.querySelector('[data-bundle-compare]');
    const saveCents = parseInt(bundle.dataset.saveCents, 10) || 0;

    if (priceEl) {
      if (saveCents > 0) {
        priceEl.textContent = formatMoney(variant.price - saveCents);
      } else if (variant.price_formatted) {
        priceEl.innerHTML = variant.price_formatted;
      }
    }

    if (compareEl && saveCents > 0) {
      compareEl.textContent = formatMoney(variant.price);
    }
  }

  function getActiveBundles() {
    return Array.from(document.querySelectorAll('[data-bundle-addon]')).filter((b) => {
      const cb = b.querySelector('[data-bundle-checkbox]');
      return cb && cb.checked;
    });
  }

  // ---- Pill click handler ----

  document.addEventListener('click', function (e) {
    const pill = e.target.closest('.bundle-addon__pill');
    if (!pill) return;

    e.preventDefault();
    e.stopPropagation();

    const bundle = pill.closest('[data-bundle-addon]');
    if (!bundle) return;

    const optionIndex = pill.dataset.bundleOptionIndex;

    bundle
      .querySelectorAll(`.bundle-addon__pill[data-bundle-option-index="${optionIndex}"]`)
      .forEach((p) => p.classList.remove('is-selected'));

    pill.classList.add('is-selected');
    updateBundlePriceAndCompare(bundle);
  });

  // ---- Variant sync from main picker ----

  function syncBundleToOptions(bundle, selectedValues) {
    if (bundle.dataset.syncVariant !== 'true') return;

    const data = parseVariants(bundle);
    if (!data || !data.optionNames) return;

    const bundleOptionNames = data.optionNames;
    let didChange = false;

    bundleOptionNames.forEach((bundleOptName, idx) => {
      const mainValue = selectedValues[idx];
      if (!mainValue) return;

      const pills = bundle.querySelectorAll(
        `.bundle-addon__pill[data-bundle-option-index="${idx}"]`
      );

      const match = Array.from(pills).find(
        (p) =>
          p.dataset.bundleOptionValue === mainValue ||
          p.dataset.bundleOptionValue.toLowerCase() === mainValue.toLowerCase()
      );

      if (match && !match.classList.contains('is-selected')) {
        pills.forEach((p) => p.classList.remove('is-selected'));
        match.classList.add('is-selected');
        didChange = true;
      }
    });

    if (didChange) updateBundlePriceAndCompare(bundle);
  }

  document.addEventListener('fino:variant-changed', function (e) {
    const selectedValues = (e.detail && e.detail.selectedOptions) || [];
    document.querySelectorAll('[data-bundle-addon]').forEach((bundle) => {
      syncBundleToOptions(bundle, selectedValues);
    });
  });

  // ---- Initial sync on page load ----

  function initialSync() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    const selectedValues = [];
    picker.querySelectorAll('fieldset').forEach((fs, idx) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      const label = checked.closest('label');
      const textEl = label ? label.querySelector('.variant-option__button-label__text') : null;
      const val = textEl && textEl.dataset.finoOriginal
        ? textEl.dataset.finoOriginal
        : checked.value;
      selectedValues[idx] = val;
    });

    document.querySelectorAll('[data-bundle-addon]').forEach((bundle) => {
      syncBundleToOptions(bundle, selectedValues);
      updateBundlePriceAndCompare(bundle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

  // ---- Bundle Add via cart event listener ----

  console.log('[Fino Bundle] Initializing cart event listener');

  let bundleAddingNow = false;

  // Helper: collect all section IDs Horizon needs to refresh
  function getCartSectionIds() {
    const sectionIds = new Set();

    // Get section ID from cart-items-component (the cart drawer)
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
      sectionIds.add(el.dataset.sectionId);
    });

    // Also include cart-icon and cart-bubble sections if present
    document.querySelectorAll('[data-section-id]').forEach((el) => {
      const id = el.dataset.sectionId;
      if (id && (id.includes('cart') || id.includes('header'))) {
        sectionIds.add(id);
      }
    });

    return Array.from(sectionIds);
  }

  async function fireBundleAdds(triggerEvent) {
    if (bundleAddingNow) {
      console.log('[Fino Bundle] Already adding — skipping duplicate');
      return;
    }

    const activeBundles = getActiveBundles();
    if (activeBundles.length === 0) return;

    console.log('[Fino Bundle] Cart event "' + (triggerEvent ? triggerEvent.type : 'unknown') + '" fired — adding', activeBundles.length, 'bundles');

    bundleAddingNow = true;

    try {
      const bundleItems = [];
      const bundleVariantIds = [];

      for (const bundle of activeBundles) {
        const variant = findMatchingVariant(bundle);
        if (variant && variant.id) {
          bundleItems.push({ id: variant.id, quantity: 1 });
          bundleVariantIds.push(variant.id);
        }
      }

      if (bundleItems.length === 0) {
        console.warn('[Fino Bundle] No bundle variants matched');
        return;
      }

      // Skip if already in cart
      try {
        const checkRes = await fetch('/cart.js');
        const checkCart = await checkRes.json();
        const alreadyInCart = bundleVariantIds.every((id) =>
          checkCart.items.some((item) => item.variant_id === id)
        );
        if (alreadyInCart) {
          console.log('[Fino Bundle] Bundle items already in cart, skipping add');
          return;
        }
      } catch (e) { /* proceed anyway */ }

      // Get section IDs that need refreshing
      const sectionIds = getCartSectionIds();
      console.log('[Fino Bundle] Will refresh sections:', sectionIds);

      // Build form-encoded body — Shopify's add.js with sections param
      // requires form encoding for the sections array to work properly
      const formBody = new URLSearchParams();
      bundleItems.forEach((item, i) => {
        formBody.append(`items[${i}][id]`, item.id);
        formBody.append(`items[${i}][quantity]`, item.quantity);
      });
      sectionIds.forEach((id) => {
        formBody.append('sections[]', id);
      });
      formBody.append('sections_url', window.location.pathname);

      console.log('[Fino Bundle] Posting bundle with sections');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formBody.toString(),
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error('[Fino Bundle] Add failed:', res.status, errorText);
        return;
      }

      const data = await res.json();
      console.log('[Fino Bundle] Bundle added successfully. Sections returned:', data.sections ? Object.keys(data.sections) : 'none');

      // Uncheck bundles after successful add
      activeBundles.forEach((bundle) => {
        const cb = bundle.querySelector('[data-bundle-checkbox]');
        if (cb) cb.checked = false;
      });

// Get fresh cart data
      const cartRes = await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } });
      const cartData = await cartRes.json();

      console.log('[Fino Bundle] Cart now has', cartData.item_count, 'items');

      // Manually swap the cart-items-component innerHTML using the section
      // that Shopify just rendered fresh for us in data.sections
      try {
        if (data.sections) {
          for (const [sectionId, sectionHtml] of Object.entries(data.sections)) {
            console.log('[Fino Bundle] Processing section:', sectionId);

            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHtml, 'text/html');

            // Find the new cart-items-component in the fresh HTML
            const newCartItems = doc.querySelector('cart-items-component');
            const liveCartItems = document.querySelector('cart-items-component[data-section-id="' + sectionId + '"]');

            if (newCartItems && liveCartItems) {
              liveCartItems.innerHTML = newCartItems.innerHTML;
              console.log('[Fino Bundle] Swapped cart-items-component innerHTML for section:', sectionId);
            } else {
              console.log('[Fino Bundle] Could not find matching cart-items-component for', sectionId,
                '- new:', !!newCartItems, 'live:', !!liveCartItems);
            }

            // Also update cart bubble inside this section's HTML
            const newBubbleCount = doc.querySelector('.cart-bubble__text-count');
            if (newBubbleCount) {
              document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
                el.textContent = newBubbleCount.textContent.trim();
              });
            }
          }
        }
      } catch (e) {
        console.warn('[Fino Bundle] Section swap failed:', e);
      }

      // Update bubble count from cart.js as a safety net
      document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
        if (!el.textContent.trim()) el.textContent = cartData.item_count;
      });

      console.log('[Fino Bundle] Cart drawer should now be refreshed');
    } catch (err) {
      console.error('[Fino Bundle] Bundle add error:', err);
    } finally {
      setTimeout(() => {
        bundleAddingNow = false;
      }, 1500);
    }
  }

  // Listen ONLY for cart:update (Horizon's primary event)
  // We removed the wildcard listeners because dispatching back was causing Horizon to crash
  document.addEventListener('cart:update', fireBundleAdds);
})();